const TYPES = {
    PRODUCT: 'product',
    ARTICLE: 'article',
}

export default TYPES